"use client";

import ReadMore from "@/components/ReadMore";
import VisionAccordion from "@/components/VisionAccordion/VisionAccordion";
import { setInquiryPopupObj } from "@/store/slices/inquirySlice";
import Image from "next/image";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
// import { useNavigate, useParams } from "react-router";
// import ReadMore from "../components/ReadMore";
// import Seo from "../components/Seo";
// import { CountryList } from "../services/CountryList";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import OtherPageBanner from "@/components/OtherPageBanner/OtherPageBanner";

export default function AboutUs({ aboutUsData }) {
  //   const [aboutUsData, setAboutUs] = useState(aboutDetails || null);
  const [isMobilescreen, setMobilescreen] = useState(false);
  console.log(aboutUsData);
  const dispatch = useDispatch();
  const fadeUpVariant = {
    hidden: {
      opacity: 0,
      filter: "blur(10px)",
    },
    visible: {
      opacity: 1,
      filter: "blur(0px)",
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const scaleFadeVariant = {
    hidden: {
      opacity: 0,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };
  useEffect(() => {
    // let aboutData = {};
    // if (aboutUsData == null) {
    //   aboutData = pageList.find((page) => page.slug == "about-us");
    //   setAboutUs(aboutData);
    // }

    if (window.innerWidth <= 767) setMobilescreen(true);
    dispatch(setInquiryPopupObj(null));
  }, []);

  //   const seoMetaData = aboutUsData && {
  //     page_title: aboutUsData.seo_title || "About  Us | Swati Procon",
  //     page_description: aboutUsData.seo_description,
  //     page_keywords: aboutUsData.seo_keywords,
  //     slug: aboutUsData.slug,
  //     image: aboutUsData.seo_image_full
  //       ? aboutUsData.seo_image_full.includes("?")
  //         ? `${aboutUsData.seo_image_full}&w=1280&h=640`
  //         : `${aboutUsData.seo_image_full}?w=1280&h=640`
  //       : "/images/og-img.jpeg",
  //   };
  if (aboutUsData == null) {
    return <>Please Wait..</>;
  }
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const [showMore, setShowMore] = useState(false);

  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  return (
    <>
      {/* {seoMetaData && <Seo metaData={seoMetaData} />} */}
      <div
        className="reecosys-main-wrapper aboutus-page-wrapper"
        id="reecosys-main-wrapper"
      >
        <div
          id="reecosys-aboutus-wrapper"
          className="relative  section-padding pt0"
        >
          {/* <section
            className="reecosys-section relative"
            id="reecosys-aboutus-section-2"
          >
            <div className="award-section main-container-fluid">
              <motion.div
                className="new-about-grid-card"
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
              >
                <div className="flex-row j-c-sb about-main">
                  <motion.div
                    className="section-information"
                    variants={fadeUpVariant}
                  >
                    <div className="section-title64">
                      <h2 className="">
                        About <br className=""></br>NB Group
                      </h2>
                    </div>
                  </motion.div>
                  <motion.div
                    className="about-banner"
                    variants={scaleFadeVariant}
                  >
                    <img
                      src="/images/about/about-banner.png"
                      alt=""
                      className="hide-mobile-only"
                    />
                    <img
                      src="/images/about/about-sec1-mg.png"
                      alt=""
                      className="visible-mobile-only"
                    />
                  </motion.div>
                </div>
                <motion.div
                  variants={fadeUpVariant}
                  className="about-desc inner-flex inner-flex-medium"
                >
                  <div className="inner-flex">
                    {aboutUsData.primary_text_display && (
                      <div className="section-content22 readmoreText readmore-span-color">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: aboutUsData.primary_text_display,
                          }}
                        />
                      </div>
                    )}
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </section> */}

          {/* <div className="fact-section relative award-section main-container-fluid section-paddinglarge">
            <div className="about-border"></div>
            <motion.div
              className="fact-main inner-flex"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={staggerContainer}
            >
              <div className="fact1">
                <div className="section-subtitle">
                  <h4 className="semibold-fonts">Facts and Figures</h4>
                </div>
              </div>
              <div ref={ref} className="fact-information flex-row">
                <motion.div
                  variants={scaleFadeVariant}
                  className="innerflex fact-flex"
                >
                  <div className="section-title64">
                    <h2 className="semibold-fonts">
                      {inView && <CountUp start={0} end={30} duration={2} />}
                      <span style={{ fontWeight: "700" }}>L+</span>
                    </h2>
                  </div>
                  <div className="section-content">
                    <p className="neue-light-fonts">Sq. Ft. Area Constructed</p>
                  </div>
                </motion.div>

                <div className="about-border2 hide-mobile-only"></div>

                <div className="innerflex fact-flex">
                  <div className="section-title64">
                    <h2 className="semibold-fonts">
                      {inView && <CountUp start={0} end={15} duration={2} />}
                      <span style={{ fontWeight: "700" }}>+</span>
                    </h2>
                  </div>
                  <div
                    className="section-content"
                    style={{ width: "max-content" }}
                  >
                    <p className="neue-light-fonts">Years of Experience</p>
                  </div>
                </div>

                <div className="about-border2 hide-mobile-only"></div>

                <div className="innerflex fact-flex">
                  <div className="section-title64">
                    <h2 className="semibold-fonts">
                      {inView && (
                        <CountUp
                          start={0}
                          end={1000}
                          duration={2}
                          separator=","
                        />
                      )}
                      <span style={{ fontWeight: "700" }}>+</span>
                    </h2>
                  </div>
                  <div className="section-content">
                    <p className="neue-light-fonts">Units Delivered</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div> */}
          <OtherPageBanner
            title="About"
            subtitle="Building Beyond Spaces"
            description="We, NB Group, are a real estate developer that have steadily shaped Ahmedabad's skyline with integrity, innovation, and a clear vision. Led by visionary leadership, we go beyond conventional boundaries to create homes and communities that deliver a deeper quality of living; where ethical construction, sustainability, and the well- being of every community are always at the heart of every decision. Our Group has been in the export and import of Diamonds worldwide since early 90s. From shaping diamonds to shaping landmarks, we have come a long way, applying our global experience, technology and expertise in all our areas of businesses."
            bannerWeb={aboutUsData?.banner_web_full}
            highlights={true}
          />
          <div className="vision-section relative award-section main-container-fluid">
            {/* <div className="about-border"></div> */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={staggerContainer}
              className="vision-main section-paddinglarge flex-row inner-flex-big5"
            >
              <motion.div
                variants={scaleFadeVariant}
                className="vision1 inner-flex inner-flex-medium"
              >
                <div>
                  <img src="/images/about/vision.svg" alt="" />
                </div>
                <div className="vision1-text">
                  <div className="section-title-big">
                    <h2 className="semibold-fonts">Vision</h2>
                  </div>
                  <div className="section-content">
                    <p className="neue-light-fonts">
                      To redefine urban living by creating spaces that go beyond
                      walls — where people, design, and purpose come together to
                      build enduring communities.
                    </p>
                  </div>
                </div>
              </motion.div>
              <motion.div
                variants={scaleFadeVariant}
                className="vision1 inner-flex inner-flex-medium"
              >
                <div>
                  <img src="/images/about/mission.svg" alt="" />
                </div>
                <div className="vision1-text">
                  <div className="section-title-big">
                    <h2 className="semibold-fonts">Mission</h2>
                  </div>
                  <div className="section-content">
                    <p className="neue-light-fonts">
                      To deliver thoughtfully designed, quality-driven
                      developments that integrate architecture, sustainability,
                      and human experience — ensuring every NB project stands
                      for trust, timelessness, and transformation.
                    </p>
                  </div>
                </div>
              </motion.div>
              <motion.div
                variants={scaleFadeVariant}
                className="vision1 inner-flex inner-flex-medium"
              >
                <div>
                  <img src="/images/about/manifesto.svg" alt="" />
                </div>
                <div className="vision1-text">
                  <div className="section-title-big">
                    <h2 className="semibold-fonts">Manifesto</h2>
                  </div>
                  <div className="section-content about-text-wrapper">
                    <p>
                      At NB Group, we believe that a space is more than what it
                      contains — it's what it inspires. For over a decade, our
                      foundation has been trust; our material, purpose. Every
                      project we create is designed not just to stand tall,
                      {!showMore && (
                        <span
                          className="read-more-btn"
                          onClick={() => setShowMore(true)}
                        >
                          Read More
                        </span>
                      )}
                    </p>

                    <div
                      className={`hidden-content ${
                        showMore ? "show-content" : ""
                      }`}
                    >
                      <p>
                        but to stand for something — connection, comfort, and
                        care. We build thoughtfully, where architecture meets
                        emotion and design meets detail. Our commitment to
                        quality and sustainability is not just a promise — it's
                        our philosophy. Because for us, real estate isn't only
                        about constructing walls and towers — it's about shaping
                        the way people live, work, and belong.
                      </p>

                      <span
                        className="read-more-btn"
                        onClick={() => setShowMore(false)}
                      >
                        Show Less
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>

          <section className="section-paddinglarge pt0">
            <div className="award-section main-container-fluid">
              <div className="about-border"></div>
              <div className="values-grid-wrapper inner-flex">
                <div className="section-subtitle relative">
                  <h4 className=" text-lef-tmovile">Brand Values</h4>
                </div>
                <div className="flex-row j-c-sb value-flex">
                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    variants={staggerContainer}
                    className="values-flex-wrapper"
                  >
                    <motion.div
                      variants={scaleFadeVariant}
                      className="values-flex-card flex-row inner-flex-medium40"
                    >
                      <div className="values-flex-icon section-title-big">
                        <h2
                          className="semibold-fonts"
                          style={{ color: " #0000003D" }}
                        >
                          01
                        </h2>
                      </div>
                      <div className="values-content-wrapper">
                        <div className="section-title-big">
                          <h2 className="semibold-fonts">Integrity</h2>
                        </div>
                        <div className="section-content">
                          <p>
                            Lay down regulations and make sure everyone adheres
                            to them
                          </p>
                        </div>
                      </div>
                    </motion.div>
                    <div className="values-flex-card flex-row inner-flex-medium40">
                      <div className="values-flex-icon section-title-big">
                        <h2
                          className="semibold-fonts"
                          style={{ color: " #0000003D" }}
                        >
                          02
                        </h2>
                      </div>
                      <div className="values-content-wrapper">
                        <div className="section-title-big">
                          <h2 className="semibold-fonts">Sustainability</h2>
                        </div>
                        <div className="section-content">
                          <p>
                            Keeping a balance in our ecosystem by adopting green
                            practices
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="values-flex-card flex-row inner-flex-medium40">
                      <div className="values-flex-icon section-title-big">
                        <h2
                          className="semibold-fonts"
                          style={{ color: " #0000003D" }}
                        >
                          03
                        </h2>
                      </div>
                      <div className="values-content-wrapper">
                        <div className="section-title-big">
                          <h2 className="semibold-fonts">Team Work</h2>
                        </div>
                        <div className="section-content">
                          <p>
                            Initiate and maintain collaborative efforts to
                            maximize our collective potential
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="values-flex-card flex-row inner-flex-medium40">
                      <div className="values-flex-icon section-title-big">
                        <h2
                          className="semibold-fonts"
                          style={{ color: " #0000003D" }}
                        >
                          04
                        </h2>
                      </div>
                      <div className="values-content-wrapper">
                        <div className="section-title-big">
                          <h2 className="semibold-fonts">Timely Delivery</h2>
                        </div>
                        <div className="section-content">
                          <p>
                            Achieve on-time, on-budget, goal-focused delivery of
                            projects to build trust
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="values-flex-card flex-row inner-flex-medium40">
                      <div className="values-flex-icon section-title-big">
                        <h2
                          className="semibold-fonts"
                          style={{ color: " #0000003D" }}
                        >
                          05
                        </h2>
                      </div>
                      <div className="values-content-wrapper">
                        <div className="section-title-big">
                          <h2 className="semibold-fonts">Responsibility</h2>
                        </div>
                        <div className="section-content">
                          <p>
                            Carrying out our activities in line with our values
                            and sharing them with clients
                          </p>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                  <div className="brand-image">
                    <img
                      src="/images/about/brand-values/Brand-mainimage.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className="reecosys-section relative"
            id="reecosys-aboutus-section-3"
          >
            <div className="award-section main-container-fluid section-padding-bottom ">
              <div className="about-border"></div>
              {aboutUsData && (
                <div className="flex-row j-c-sb leadership-section">
                  <div className="inner-flex leadership-main">
                    <div className="section-subtitle relative">
                      <h4 className=" text-lef-tmovile">Leadership</h4>
                    </div>

                    {aboutUsData.team_description && (
                      <div className="section-paragraph2">
                        <p
                          className=""
                          dangerouslySetInnerHTML={{
                            __html: aboutUsData.team_description,
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <motion.div
                    className="grid-two-50-50-small profile_image_grid leadership-grid"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.15 }}
                    variants={staggerContainer}
                  >
                    {aboutUsData.profiles &&
                      aboutUsData.profiles.map((data, index) => (
                        <motion.div
                          key={index}
                          className="inner-flex inner-flex-small"
                          variants={scaleFadeVariant}
                          onClick={() => {
                            setSelectedProfile(data);
                            setPopupOpen(true);
                          }}
                        >
                          <div
                            className="leadership-image"
                            onClick={() => {
                              setSelectedProfile(data);
                              setPopupOpen(true);
                            }}
                          >
                            <img
                              src={`${data.profile_image_main}&w=400&q=100`}
                              alt={data.profile_name}
                              style={{
                                width: "100%",
                                objectPosition:"top",
                                height: "auto",
                                aspectRatio: "0.9",
                              }}
                            />
                          </div>

                          <div className="">
                            <div className="inner-flex">
                              <div className="flex-row j-c-sb alc inner-flex-smallest">
                                {data.profile_name && (
                                  <div className="leader-name section-paragraph2 ">
                                    <div className="flex-row j-c-sb">
                                      <p className="semibold-fonts">
                                        {data.profile_name}
                                      </p>
                                      <div
                                        className="section-paragraph2 about-plus "
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setSelectedProfile(data);
                                          setPopupOpen(true);
                                        }}
                                      >
                                        <p
                                          className="semibold-fonts leadership-plus"
                                          style={{ fontWeight: "700" }}
                                        >
                                          +
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="leadership-desc section-content18 leadership-short-desc"
                                      dangerouslySetInnerHTML={{
                                        __html: data.designation,
                                      }}
                                      onClick={() => {
                                        setSelectedProfile(data);
                                        setPopupOpen(true);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    ></div>
                                  </div>
                                )}

                                <div className="menber_social_links">
                                  <ul className="flex-row flex-row-socccc js-end alc">
                                    {data.facebook_url && (
                                      <li>
                                        <a
                                          href={data.facebook_url}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <div className="member_social_icons">
                                            <img
                                              src="/images/icon/social-icons/facebook.svg"
                                              alt={data.profile_name}
                                            />
                                          </div>
                                        </a>
                                      </li>
                                    )}
                                    {data.linkedin_url && (
                                      <li>
                                        <a
                                          href={data.linkedin_url}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <div className="member_social_icons">
                                            <img
                                              src="/images/icon/social-icons/linkedin.svg"
                                              alt={data.profile_name}
                                            />
                                          </div>
                                        </a>
                                      </li>
                                    )}
                                    {data.instagram_url && (
                                      <li>
                                        <a
                                          href={data.instagram_url}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <div className="member_social_icons">
                                            <img
                                              src="/images/icon/social-icons/instagram.svg"
                                              alt={data.profile_name}
                                            />
                                          </div>
                                        </a>
                                      </li>
                                    )}
                                    {data.twitter_url && (
                                      <li>
                                        <a
                                          href={data.twitter_url}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <div className="member_social_icons">
                                            <img
                                              src="/images/icon/social-icons/twitter.svg"
                                              alt={data.profile_name}
                                            />
                                          </div>
                                        </a>
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      ))}
                  </motion.div>
                </div>
              )}
            </div>

            <div
              className={`popup-overlay ${popupOpen ? "active" : ""}`}
              onClick={() => setPopupOpen(false)}
            ></div>

            <div className={`leadership-popup ${popupOpen ? "active" : ""}`}>
              <div className="flex-row inner-flex-big5 popup-1">
                <div className="leadership-image-popup">
                  <img

                    src={`${selectedProfile?.profile_image_main}&w=400&q=100`}
                    alt={selectedProfile?.profile_name}
                    style={{objectPosition:"tops"}}
                  />
                </div>

                <div className="popup-text1 inner-flex">
                  <div className="section-subtitle">
                    <h4 className="white-color regular-fonts">
                      {selectedProfile?.profile_name}
                    </h4>
                  </div>

                  <div
                    className="section-content18 white-color popup-desc"
                    dangerouslySetInnerHTML={{
                      __html: selectedProfile?.designation || "",
                    }}
                  />
                  <div
                    className="section-content18 white-color"
                    dangerouslySetInnerHTML={{
                      __html: selectedProfile?.profile_description_short || "",
                    }}
                  />
                </div>
              </div>

              <div className="popup-logo">
                <img src="/images/about/about-page-vector.svg" alt="" />
              </div>

              <div
                className={`popup-cross ${!popupOpen ? "closing" : ""}`}
                onClick={() => setPopupOpen(false)}
              >
                <span></span>
                <span></span>
              </div>
            </div>
          </section>
          <div className="about-border  award-section main-container-fluid"></div>
          <section className="awards-padding section-padding ">
            <div className="award-section main-container-fluid">
              <div className="award-section-main flex-row j-c-sb">
                <div className="section-subtitle relative">
                  <h4 className=" text-lef-tmovile">Awards</h4>
                </div>
                <div className="awards-grid hide-mobile-only">
                  <motion.div
                    variants={scaleFadeVariant}
                    className="awards-card"
                  >
                    <div
                      className="awrds-image"
                      style={{ aspectRatio: "1", position: "relative" }}
                    >
                      <Image
                        src="/images/awards/Ahmedabad Mirror.png"
                        alt=""
                        fill
                        sizes="(max-width: 768px) 100vw, 33vw"
                        style={{
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div className="awards-image-text section-paragraph2">
                      <p className="semibold-fonts">Ahmedabad Mirror</p>
                    </div>
                  </motion.div>
                  <div className="awards-card">
                    <div
                      className="awrds-image"
                      style={{ aspectRatio: "1", position: "relative" }}
                    >
                      <Image
                        src="/images/awards/CEO Insights Magazine.png"
                        alt=""
                        fill
                        sizes="(max-width: 768px) 100vw, 33vw"
                        style={{
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div className="section-paragraph2">
                      <p className="semibold-fonts">CEO Insights Magazine</p>
                    </div>
                  </div>
                  <div className="awards-card">
                    <div
                      className="awrds-image"
                      style={{ aspectRatio: "1", position: "relative" }}
                    >
                      <Image
                        src="/images/awards/CEO Insights.png"
                        alt=""
                        fill
                        sizes="(max-width: 768px) 100vw, 33vw"
                        style={{
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div className="section-paragraph2">
                      <p className="semibold-fonts">CEO Insights</p>
                    </div>
                  </div>
                </div>
                <div className="mobile-only awards-swiper visible-mobile-only">
                  <Swiper
                    modules={[Pagination]}
                    slidesPerView={1}
                    spaceBetween={20}
                    pagination={{
                      clickable: true,
                    }}
                  >
                    <SwiperSlide>
                      <div className="awards-card">
                        <div
                          className="awrds-image"
                          style={{ aspectRatio: "1", position: "relative" }}
                        >
                          <Image
                            src="/images/awards/Ahmedabad Mirror.png"
                            alt=""
                            fill
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                        <div className="section-paragraph2">
                          <p className="semibold-fonts">Ahmedabad Mirror</p>
                        </div>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="awards-card">
                        <div
                          className="awrds-image"
                          style={{ aspectRatio: "1", position: "relative" }}
                        >
                          <Image
                            src="/images/awards/CEO Insights Magazine.png"
                            alt=""
                            fill
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                        <div className="section-paragraph2">
                          <p className="semibold-fonts">
                            CEO Insights Magazine
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="awards-card">
                        <div
                          className="awrds-image"
                          style={{ aspectRatio: "1", position: "relative" }}
                        >
                          <Image
                            src="/images/awards/CEO Insights.png"
                            alt=""
                            fill
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                        <div className="section-paragraph2">
                          <p className="semibold-fonts">CEO Insights</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
